import { HttpRequest, HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IMedia } from '@models/shared/utils/media';
import { APP_CONFIG } from '../tokens/app-config.token';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  protected http = inject(HttpClient);
  private appConfig = inject(APP_CONFIG);

  private get baseURL() {
     return this.appConfig.apiUrl + 'media';
  }
  
  private get docURL() {
    return this.appConfig.apiUrl + 'docs';
  }

  private get apiURL() {
    return this.appConfig.apiUrl + 'public/media/view';
  }

  mediaURL = this.apiURL;
  defaultImg = '/assets/media/svg/avatars/blank.svg';

  saveMedia(mda: IMedia[]): Observable<any> {
    const formData = new FormData();
    mda.forEach(m => {
      formData.append('files', m.mda_file);
    });
    return this.http.post(`${this.baseURL}/add`, formData);
  }

  getUrl(mda: IMedia): string {
    return `${this.docURL}/${mda.mda_file_loc}`;
  }

  uploadFile(mdas: IMedia[]): Observable<any> {
    const mdaFiles = mdas.map(m => m.mda_file);
    if (mdaFiles && mdaFiles.length > 0) {
      const formData: FormData = new FormData();
      mdaFiles.forEach(f => {
        formData.append('files[]', f);
      });
      const req = new HttpRequest('POST', `${this.baseURL}/add`, formData, {
        responseType: 'json'
      });

      return this.http.request(req);
    } else {
      return of(new HttpResponse<any>());
    }
  }

  deleteMedia() {
    console.log('deleteMedia');
  }

  getImageBase64FromUUID(uuid: string) {
    console.log('getImageBase64FromUUID');
  }

  getURLByUUID(uuid: string | undefined): string {
    if (uuid) {
      return `${this.apiURL}/${uuid}`;
    }
    return this.defaultImg;
  }
}
